import React from 'react';

import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';

import FieldsPage from '../fields/FieldsPage';
import MyCulturesTab from './MyCulturesTab';
import MyDevicesTab from './MyDevicesTab';

import { Zond } from '../../models/Zond';

interface Props {
    zonds: Zond[];
}

const SettingsPage = (props: Props) => {
    const location = useLocation();

    if (location.pathname.endsWith('/cultures')) {
        return <MyCulturesTab />;
    }

    if (location.pathname.endsWith('/devices')) {
        return <MyDevicesTab zonds={props.zonds} />;
    }

    return <FieldsPage />;
};

const mapStateToProps = (state: any) => ({
    zonds: state.zonds.zonds,
});

export default connect(mapStateToProps)(SettingsPage);
